import { Pipe, PipeTransform } from '@angular/core';
import { formatSentimentCellDisplay } from './sentiment-cell-display.util';

@Pipe({ name: 'sentimentText', standalone: true })
export class SentimentTextPipe implements PipeTransform {
  transform(value: unknown): string {
    return formatSentimentCellDisplay(value);
  }
}
